<template>
  <vue-final-modal v-slot="{ close }">
    <div class="loginmodal">
      <div class="art" :class="level"><!-- agreeart warningart -->
        <span class="img"></span>
        <p v-html="$t(code)"></p>
        <div class="btn">
          <template v-if="type == 'confirm'">
            <button class="yes" @click="$emit('confirm', 'yes', close)">{{$t('front.button.yes')}}</button>
            <button class="no" @click="$emit('confirm', 'no', close)">{{$t('front.button.no')}}</button>
          </template>

          <template v-if="type == 'check'">
            <button class="yes" @click="$emit('check', 'ok', close)">{{$t('front.button.confirm')}}</button>
          </template>
        </div>
        <button class="closeart" @click="onClose(close)"><img src="@/assets_mobile/img/icon_delete.svg" /></button>
      </div>
    </div>
  </vue-final-modal>
</template>

<script>

import Alert from '@/components/common/Alert'

export default {
  name: 'AlertMobile',
  mixins: [Alert]
}
</script>

<style scoped>
button {cursor: pointer;}
.loginmodal {padding: 18px;box-sizing: border-box;background: rgba(3, 2, 7, .84) !important;backdrop-filter: blur(7px);}
.art {position: relative;top: 50%;width: min(100%, 336px);margin: 0 auto;padding: 38px 22px 22px;box-sizing: border-box;transform: translateY(-50%);text-align: left;border: 1px solid rgba(172, 70, 115, .48);border-radius: 12px;background: #0c0910;box-shadow: 0 22px 56px rgba(0, 0, 0, .62), inset 0 1px 0 rgba(255, 255, 255, .025);}
.art .img {display: none;}
.art p {margin: 0;padding-right: 22px;font-size: 14px;font-weight: 600;letter-spacing: -.025em;color: rgba(255, 255, 255, .86);line-height: 1.55em;}
.art .btn {display: flex;justify-content: flex-end;gap: 8px;margin-top: 24px;}
.art .yes, .art .no {flex: 1;height: 40px;box-sizing: border-box;border-radius: 6px;font-size: 14px;font-weight: 700;letter-spacing: -.02em;}
.art .yes {color: #fff;border: 1px solid #c34a82;border-top-color: #dd70a2;border-bottom-color: #7b1f4a;background: #aa3269;box-shadow: inset 0 1px 0 rgba(255, 255, 255, .12), 0 7px 16px rgba(107, 20, 61, .2);}
.art .no {color: rgba(255, 255, 255, .72);border: 1px solid rgba(164, 121, 143, .3);background: #181219;}
.closeart {width: 28px;height: 28px;padding: 6px;background: none;border: 0;position: absolute;right: 10px;top: 10px;box-sizing: border-box;opacity: .62;}
.closeart img {display: block;width: 100%;height: 100%;object-fit: contain;filter: brightness(0) invert(1);}
</style>
<style scoped src="@/styles/header.css"></style>
<style scoped src="@/styles/common.css"></style>
<style scoped src="@/styles/subcommon.css"></style>
